import React from "react";
import Layout from "../../Components/Layout";
import './styles.scss'

export default function License() {
  return(
    <Layout>
        <div className="licenseContainer">
            <h1>
                Licenças
            </h1>
            <a href="http://www.freepik.com">Laptop Designed by Layerace / Freepik</a>
        </div>
    </Layout>    
)
}
